export enum CustomHeaders {
  MsAccessToken = 'x-access-token',
}
